var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-switch',{staticClass:"mt-2",on:{"click":function($event){return _vm.setVal($event)}},model:{value:(_vm.IsPublished),callback:function ($$v) {_vm.IsPublished=$$v},expression:"IsPublished"}})
}
var staticRenderFns = []

export { render, staticRenderFns }